import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SectoresService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description recuperar sectores
   */
  getSectors(): Observable<any> {
    const headerConfig: any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/x-www-form-urlencoded')
    };

    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.sectorListar.name,
      headerConfig
    ).pipe(
      map((e: any) => {
        const sectorList: any[] = e;
        return sectorList.map(sector => ({ id: sector.idSector, name: sector.desSector }));
      })
    );
  }
}
